/* unplugin-vue-components disabled */import { render } from "./layout-aside.vue?vue&type=template&id=41e9a12e&scoped=true"
import script from "./layout-aside.vue?vue&type=script&lang=js"
export * from "./layout-aside.vue?vue&type=script&lang=js"

import "./layout-aside.vue?vue&type=style&index=0&id=41e9a12e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e9a12e"]])

export default __exports__